import { render, staticRenderFns } from "./FormOtherTipoRegistro.vue?vue&type=template&id=779dbcf2"
import script from "./FormOtherTipoRegistro.vue?vue&type=script&lang=js"
export * from "./FormOtherTipoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports